import { QUOTES_TYPE } from "@/common/const/types/index.const";
import diaIptFormResStrategy from "./diaRes.strategy";
import biaResStrategy from "./biaRes.strategy";
import wiaResStrategy from "./wiaRes.strategy";
import ipAddressResStrategy from "./ipAddressRes.strategy";
import eplResStrategy from "./eplRes.strategy";
import hardwareResStrategy from "./hardwareRes.strategy";
import fieldServiceResStrategy from "./fieldServiceRes.strategy";
import dcRackResStrategy from "./dcRackRes.strategy";
import dcCrossConnectResStrategy from "./dcCrossConnectRes.strategy";

const manualResQuote = {
  [QUOTES_TYPE[0]]: diaIptFormResStrategy,
  [QUOTES_TYPE[1]]: diaIptFormResStrategy,
  [QUOTES_TYPE[2]]: biaResStrategy,
  [QUOTES_TYPE[3]]: wiaResStrategy,
  [QUOTES_TYPE[4]]: ipAddressResStrategy,
  [QUOTES_TYPE[5]]: eplResStrategy,
  [QUOTES_TYPE[6]]: eplResStrategy,
  [QUOTES_TYPE[7]]: hardwareResStrategy,
  [QUOTES_TYPE[8]]: fieldServiceResStrategy,
  [QUOTES_TYPE[9]]: dcRackResStrategy,
  [QUOTES_TYPE[10]]: dcCrossConnectResStrategy,
};
export default manualResQuote;
